import { UIHeading1 } from '@cian/ui-kit/typography';
import cx from 'clsx';
import * as React from 'react';

import * as styles from './styles.css';

export interface IReviewsCounterProps {
  className?: string;
  children: React.ReactNode;
}

export function ReviewsCounter({ className, children }: IReviewsCounterProps) {
  return (
    <div className={cx(styles['reviews'], className)}>
      <UIHeading1>{children}</UIHeading1>
    </div>
  );
}
